import { render, staticRenderFns } from "./SliceTable.vue?vue&type=template&id=650abe28&scoped=true"
import script from "./SliceTable.vue?vue&type=script&lang=js"
export * from "./SliceTable.vue?vue&type=script&lang=js"
import style0 from "./SliceTable.vue?vue&type=style&index=0&id=650abe28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650abe28",
  null
  
)

export default component.exports